import { Photo } from '@types';

export type StartEndDates = { start: Date; end: Date };

export const getStartEndDates = (photos: Photo[]) =>
  photos.reduce<StartEndDates>(
    (data, photo) => {
      const date = new Date(photo.date);
      if (!data.start || date < data.start) {
        data.start = date;
      }
      if (!data.end || date > data.end) {
        data.end = date;
      }
      return data;
    },
    { start: null, end: null }
  );
